export default {
  allAccessBillingPrompt: (plan: string): string =>
    `You are making the following changes to your current ${plan} subscription. You will be charged today for a pro-rated amount equal to the time left in the current billing cycle. Subsequent charges will be part of your normal subscription bill.`,
  allAccessDeleteNotice: (addOns: string): string =>
    `Your current add-ons to ${addOns} will be cancelled.`,
  billingPrompt: (plan: string): string =>
    `You are making the following changes to your current ${plan} subscription. You will be charged today for a pro-rated amount equal to the time left in the current billing cycle. Subsequent charges will be part of your normal subscription bill.`,
  cancel: "Cancel",
  genericErrorText:
    "An error occurred when processing your transaction. Please try again.",
  goback: "Go back",
  paymentDeclinedText1:
    "Your credit card was declined. Update your payment method ",
  paymentDeclinedText2:
    ' and try submitting again by clicking "Submit Again" below.',
  submit: "Submit",
  submitAgain: "Submit Again",
  subscriptionChanges: "Subscription Changes",
  updatePayment: "Update Payment"
};
